"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

type AppDownloadButtonsProps = {
  className?: string;
  buttonWidthClass?: string;
  stackOnMobile?: boolean;
};

const DEFAULT_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.mintops.gritizer&pcampaignid=web_share";
const DEFAULT_APPLE_URL = "https://apps.apple.com/app/gritizer/id6745783053";

export const AppDownloadButtons = ({
  className,
  buttonWidthClass = "w-48 sm:w-56",
  stackOnMobile = true,
}: AppDownloadButtonsProps) => {
  const t = useTranslations("thank_you");
  const playStoreUrl =
    process.env.NEXT_PUBLIC_PLAY_STORE_URL ?? DEFAULT_PLAY_URL;
  const appStoreUrl =
    process.env.NEXT_PUBLIC_APP_STORE_URL ?? DEFAULT_APPLE_URL;

  const layoutClass = stackOnMobile
    ? "flex flex-col gap-4 sm:flex-row"
    : "flex flex-row flex-wrap gap-4";

  return (
    <div className={cn(layoutClass, className)}>
      <a
        href={playStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("google_play")}
      >
        <Image
          src="/GetItOnGooglePlay_Badge_Web_color_English.svg"
          width={240}
          height={80}
          alt={t("google_play")}
          className={cn(buttonWidthClass, "h-auto")}
        />
      </a>
      <a
        href={appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("app_store")}
      >
        <Image
          src="/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
          width={240}
          height={80}
          alt={t("app_store")}
          className={cn(buttonWidthClass, "h-auto")}
        />
      </a>
    </div>
  );
};

export default AppDownloadButtons;

